import { createContext, ReactNode, useContext, useEffect } from "react";
import usePlaceARaffleStore from "../../../components/PlaceARaffle/usePlaceARaffleStore";
import useStore from "../../../stores/common/useStore";
import LendingsPageStore from "../stores/LendingsPageStore";

const LendingsPageStoreContext = createContext<LendingsPageStore | undefined>(
  undefined
);

export const LendingsPageProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const store = useStore(LendingsPageStore, []);
  const placeARaffleStore = usePlaceARaffleStore();

  useEffect(() => {
    if (!store) return;

    // TODO: add abort controller signal
    const fetchLendings = async () => {
      await store.lendingFilter.fetchFilter();
      await store.loadItemServices();
    };

    fetchLendings();

    return () => {
      store.dispose();
    };
  }, [store]);

  useEffect(() => {
    if (placeARaffleStore.collectionServices.length > 0) {
      return;
    }
    const fetchCollections = async () => {
      try {
        await placeARaffleStore.loadCollectionItems();
      } catch (error) {
        console.error("Error fetching collections:", error);
      }
    };

    fetchCollections();
  }, [placeARaffleStore.collectionServices]);

  return (
    <LendingsPageStoreContext.Provider value={store}>
      {children}
    </LendingsPageStoreContext.Provider>
  );
};

export const useLendingsPageStore = () => {
  const store = useContext(LendingsPageStoreContext);

  if (!store) {
    throw new Error(
      "useLendingsPageStore should be called inside LendingsPageProvider"
    );
  }

  return store;
};
